var _defs, _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.76 170.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .st0, .st1 {\r\n        fill: #fff;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #87bf00;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 0.12,
    y: -0.39,
    width: 173.76,
    height: 170.77,
    rx: 21.22,
    ry: 21.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.63,122.37h111.82c-.12-1.46.3-2.97,1.45-3.93,1.22-1.02,2.38-2.1,3.48-3.24h-7.83l2.94-6.42c6.68-15.81,5.53-47.27-8.04-59.2-9.4-8.26-21.81-5.06-27.76,5.3l-.48.14c-2.07-4.34-6.88-8.42-11.58-9.61-8.7-2.2-16,2.44-20.49,9.61-6.89-11.26-20.3-14.07-29.62-3.7-9.33,10.38-11.44,29.78-9.8,43.13.9,7.25,3.26,14.22,6.45,20.74h-12.62c.66,2.4,1.3,4.82,2.06,7.18h.02ZM118.78,51.09c10.5.28,14.77,16.86,15.81,25.15,1.66,13.18-.41,27.4-7.02,38.96h-20.26c7.57-16.47,5.06-36.34-1.15-52.86,2.17-5.22,6.26-11.43,12.62-11.26h0ZM102.33,70.77c3.02,12.56,3.67,26.14.12,38.65l-.86-2.5c-3.06-11.82-2.18-24.4.74-36.15h0ZM79.3,53.98c8.17-7.28,16.42.28,19.44,8.35-6.44,16.62-8.68,36.36-.7,52.86h-22.68c6.48-13.81,5.23-31.2.98-45.54-.4-1.36-2.46-6.45-2.37-7.32.19-1.86,3.85-7.04,5.32-8.35ZM69.66,74.42c.22-1.06.39-2.66,1.08-3.42,2.58,12.68,3.54,25.77.23,38.42h0c-.61.07-.37,0-.47-.33-3.27-11.14-3.18-23.32-.85-34.66h0ZM50.78,51.61c7.89-2.7,13.05,4.51,15.76,10.77-2.52,6.74-4.31,13.81-5.06,21.01-1.1,10.59-.48,22.32,4.62,31.82h0-21.06c-3.98-7.67-6.51-15.98-7.18-24.65-.78-10.26,1.14-34.91,12.9-38.94h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 17.38,
    y: 113.05,
    width: 139.01,
    height: 11.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.a7ba720212d41e1963f25adf1bd6be8e.svg";
export { ForwardRef as ReactComponent };